import PropTypes from 'prop-types';
import React from 'react';

import deprecated from '../lib/deprecated';
import { getComponentClasses } from '@99designs/utils/app';

export default class Menu extends React.Component {
    render() {
        const classes = getComponentClasses('menu', this.props.variations);

        return (
            <div role="menu" className={classes} onClick={this.props.onClick}>
                <div className="menu__inner">{this.props.children}</div>
            </div>
        );
    }
}

Menu.propTypes = {
    variations: PropTypes.array,
};

Menu.defaultProps = {
    variations: [],
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Menu.jsx